import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function BananaPancakes() {
  return (
    <>
      <HeaderWithSearch />
      <main
        style={{
          minHeight: "100vh",
          width: "100%",
          background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
          padding: 0,
          margin: 0,
        }}
      >
        <section
          className="recipe-hero-anim"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            padding: "60px 20px 40px 20px",
          }}
        >
          <h1
            className="recipe-title-anim"
            style={{
              fontSize: "3rem",
              fontWeight: "bold",
              marginBottom: 16,
              textAlign: "center",
            }}
          >
            Banana Pancakes
          </h1>
          <span className="season-badge season-fall" style={{ marginBottom: 24 }}>🍂 Best in Fall</span>
          <ImageWithFallback
            src="/banana_pancakes.jpg"
            alt="Banana Pancakes"
            className="recipe-image-anim"
            style={{
              width: 400,
              height: 300,
              objectFit: "cover",
              borderRadius: 24,
              boxShadow: "0 4px 32px rgba(0,0,0,0.10)",
              marginBottom: 32,
            }}
          />
          <div
            style={{
              maxWidth: 800,
              fontSize: "1.1rem",
              color: "#333",
              lineHeight: 1.8,
            }}
          >
            <h2 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
              Ingredients:
            </h2>
            <ul className="ingredient-list" style={{ marginBottom: 24, paddingLeft: 20 }}>
              <li>2 ripe bananas, mashed</li>
              <li>2 large eggs</li>
              <li>1 cup all-purpose flour</li>
              <li>1 cup milk</li>
              <li>2 tbsp sugar</li>
              <li>2 tsp baking powder</li>
              <li>1/2 tsp salt</li>
              <li>1/4 tsp cinnamon</li>
              <li>2 tbsp melted butter</li>
              <li>1 tsp vanilla extract</li>
              <li>Butter or oil for cooking</li>
              <li>Maple syrup for serving</li>
              <li>Fresh banana slices for topping</li>
              <li>Optional: chopped walnuts or pecans</li>
            </ul>

            <h2 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
              Instructions:
            </h2>
            <ol className="instructions-list" style={{ paddingLeft: 20 }}>
              <li style={{ marginBottom: 12 }}>
                <strong>Prepare the batter:</strong> In a large bowl, mash the ripe bananas until smooth. Add eggs and whisk together.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Mix wet ingredients:</strong> Add milk, melted butter, and vanilla extract to the banana mixture. Stir until well combined.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Combine dry ingredients:</strong> In a separate bowl, whisk together flour, sugar, baking powder, salt, and cinnamon.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Make the batter:</strong> Add the dry ingredients to the wet ingredients and gently fold together until just combined. Don't overmix - a few lumps are okay.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Heat the pan:</strong> Heat a non-stick pan or griddle over medium heat. Add a little butter or oil.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Cook pancakes:</strong> Pour 1/4 cup of batter for each pancake. Cook until bubbles form on the surface and edges look set, about 2-3 minutes.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Flip and finish:</strong> Flip pancakes and cook for another 1-2 minutes until golden brown and cooked through.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Serve:</strong> Stack pancakes on plates, top with fresh banana slices, nuts if desired, and drizzle with maple syrup.
              </li>
            </ol>

            <div
              className="chef-tips-box"
              style={{
                background: "#f8f9fa",
                padding: 20,
                borderRadius: 12,
                marginTop: 24,
              }}
            >
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips:
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Use very ripe bananas for the best flavor and sweetness</li>
                <li>Don't overmix the batter - this keeps pancakes fluffy</li>
                <li>Keep pancakes warm in a 200°F oven while cooking the rest</li>
                <li>Add chocolate chips or blueberries for extra flavor</li>
                <li>These freeze well - reheat in toaster or microwave</li>
              </ul>
            </div>

            <div
              className="health-benefits-box"
              style={{
                background: "#eef9f0",
                padding: 20,
                borderRadius: 12,
                marginTop: 24,
              }}
            >
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Bananas provide potassium and natural sweetness, which helps cut down on added sugar.</li>
                <li>Eggs and milk add protein and calcium to start the day with lasting energy.</li>
                <li>Cinnamon adds warmth and antioxidants without any extra calories.</li>
                <li>Topping with fresh banana instead of extra syrup keeps the fiber content up.</li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default BananaPancakes;